// "How this page works": the one-line link in a page's head to its section of
// the Evals guide (TOM-139). It sits in the page's `.admin-section-header`
// and takes a row of its own under the title, so it never moves the header's
// own items. Styles: styles/admin-eval-guide.css (.admin-guide-link).

import { Link } from 'react-router-dom';

import { guideHref, type GuideAnchor } from './guide';

export function GuideLink({ section }: { section: GuideAnchor }) {
  return (
    <span className="admin-guide-link">
      <Link to={guideHref(section)} data-testid="guide-link" data-guide-section={section}>
        <svg
          viewBox="0 0 24 24"
          width={16}
          height={16}
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
          <path d="M12 17h.01" />
        </svg>
        How this page works
      </Link>
    </span>
  );
}
